import React from "react";
import PillWithIconFake from "@/components/Fakes/pill-with-icon-fake";

const AllBillsFake = () => {
  return (
    <>
      <section className="container all-bills-fake">
        <div className="all-bills-fake--column-1">
          <div className="all-bills-fake--column-1--header">
            <div className="skeleton all-bills-fake--column-1--header--title" />
            <div className="skeleton all-bills-fake--column-1--header--box">
              <div className="skeleton all-bills-fake--column-1--header--box--period" />
            </div>
          </div>
          <div className="all-bills-fake--column-1--boxes">
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
            <PillWithIconFake />
          </div>
        </div>
      </section>
      <style jsx>{`
        .all-bills-fake {
          display: flex;
          flex-direction: column;
          &--column-1 {
            &--boxes {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            &--title {
              width: 20%;
              height: 24px;
            }
            &--header {
              display: flex;
              flex-direction: column;
              align-items: start;
              width: 100%;
              &--box {
                border: 1px solid #dddddd;
                border-radius: 8px;
                padding: 1rem;
                width: 100%;
                &--title {
                  width: 33%;
                  height: 30px;
                }
                &--period {
                  width: 25%;
                  height: 18px;
                }
              }
            }
          }
        }
        @media (min-width: 768px) {
          .all-bills-fake {
            flex-direction: row;
            justify-content: space-between;
            &--column-1 {
              width: 70%;
            }
            &--column-2 {
              padding: 0 2rem;
            }
          }
        }
      `}</style>
    </>
  );
};

export default AllBillsFake;
